/** The one GPU atlas for the whole app.
 *
 * The battle screen, the town/hero screens and the adventure presenter all draw
 * from the same 22 sheets. Until 2026-09-12 the adventure presenter loaded its
 * own copy: two `Atlas.load`s meant two decoded copies of ~1.25 GB in the
 * renderer process, and a 4 GB tab that Chrome killed for memory on a 16 GB
 * laptop. Built lazily, on the first screen that needs it, and never rebuilt.
 */
import { Atlas } from "@game/render";
import { assetDir } from "../base.js";

export const ASSETS = assetDir("/assets");

let gpuAtlas: Promise<Atlas> | null = null;

export function ensureGpuAtlas(): Promise<Atlas> {
  gpuAtlas ??= Atlas.load({ baseUrl: ASSETS });
  // For the `qa/` probes that read `touchedSheets`; nothing in the app uses it.
  (globalThis as { __GPU_ATLAS__?: Promise<Atlas> }).__GPU_ATLAS__ = gpuAtlas;
  return gpuAtlas;
}
